import { render } from "./UserRegist.vue?vue&type=template&id=140b03c3&scoped=true"
import script from "./UserRegist.vue?vue&type=script&lang=js"
export * from "./UserRegist.vue?vue&type=script&lang=js"

import "./UserRegist.vue?vue&type=style&index=0&id=140b03c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140b03c3"]])

export default __exports__